var React = require('react');

function Contributing (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"contributing"),React.createElement("g",{"id":"contributing","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"Group-8","transform":"translate(1.000000, 4.000000)","stroke":"#014752","strokeWidth":"1.46737435"},[React.createElement("path",{"d":"M2.93333333,15.2307692 C10.1879343,15.2307692 10.403141,7.54862783 12.4666667,5.06997135 C13.949206,3.28918139 16.7879343,11.0769231 22,11.0769231","id":"Path","key":0}),React.createElement("polyline",{"id":"Path","points":"22 18 0 18 0 0","key":1})]))]);
}

Contributing.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = Contributing;

Contributing.default = Contributing;
